import React from "react";

const PermissionsForm = ({ permissions, setPermissions }) => {
  // Handle change for main module permissions with read/write logic
  const handleModuleChange = (moduleIndex, type) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((module, index) => {
        if (index !== moduleIndex) return module;

        const updatedModule = { ...module };

        if (type === "read") {
          updatedModule.read = !module.read;
          if (!updatedModule.read) {
            // Uncheck write if read is unchecked
            updatedModule.write = false;
          }
        } else if (type === "write") {
          updatedModule.write = !module.write;
          if (updatedModule.write) {
            // Auto check read if write is checked
            updatedModule.read = true;
          }
        }

        return updatedModule;
      })
    );
  };

  // Handle change for submodule permissions with read/write logic
  const handleSubmoduleChange = (moduleIndex, submoduleIndex, type) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((module, index) => {
        if (index !== moduleIndex) return module;

        const updatedModule = { ...module };
        updatedModule.submodule = updatedModule.submodule?.map((sub, subIndex) => {
          if (subIndex !== submoduleIndex) return sub;

          const updatedSub = { ...sub };
          if (type === "read") {
            updatedSub.read = !sub.read;
            if (!updatedSub.read) {
              updatedSub.write = false;
            }
          } else if (type === "write") {
            updatedSub.write = !sub.write;
            if (updatedSub.write) {
              updatedSub.read = true;
            }
          }

          return updatedSub;
        });

        return updatedModule;
      })
    );
  };

  return (
    <div className="p-6 border-t bg-gray-50 rounded-b-lg">
      <h2 className="font-bold text-xl text-blue-900 mb-4">Permissions</h2>

      {permissions?.map((module, moduleIndex) => (
        <div
          key={module?.module}
          className="flex flex-col py-3 border-b last:border-none"
        >
          {/* Main Module */}
          <div className="flex flex-wrap items-center justify-between">
            <div className="font-semibold text-gray-800 md:w-[20%] w-full mb-2 md:mb-0">
              {module.module_name}
            </div>

            <div className="flex items-center gap-3">
              <label className="flex items-center gap-1">
                <input
                  className="cursor-pointer w-5 h-5 accent-blue-600"
                  type="checkbox"
                  checked={module.read || false}
                  onChange={() => handleModuleChange(moduleIndex, "read")}
                />
                <span>Read</span>
              </label>

              <label className="flex items-center gap-1">
                <input
                  className="cursor-pointer w-5 h-5 accent-green-600"
                  type="checkbox"
                  checked={module.write || false}
                  onChange={() => handleModuleChange(moduleIndex, "write")}
                />
                <span>Write</span>
              </label>
            </div>
          </div>

          {/* Submodules (if exist) */}
          {module?.submodule?.length > 0 && (
            <div className="pl-8 mt-3">
              {module.submodule.map((sub, submoduleIndex) => (
                <div
                  key={sub?.submodule}
                  className="flex flex-wrap items-center justify-between py-2"
                >
                  <div className="text-gray-700 md:w-[20%] w-full mb-2 md:mb-0">
                    {sub.submodule_name}
                  </div>

                  <div className="flex items-center gap-3">
                    <label className="flex items-center gap-1">
                      <input
                        className="cursor-pointer w-5 h-5 accent-blue-600"
                        type="checkbox"
                        checked={sub.read || false}
                        onChange={() =>
                          handleSubmoduleChange(moduleIndex, submoduleIndex, "read")
                        }
                      />
                      <span>Read</span>
                    </label>

                    <label className="flex items-center gap-1">
                      <input
                        className="cursor-pointer w-5 h-5 accent-green-600"
                        type="checkbox"
                        checked={sub.write || false}
                        onChange={() =>
                          handleSubmoduleChange(moduleIndex, submoduleIndex, "write")
                        }
                      />
                      <span>Write</span>
                    </label>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PermissionsForm;
